import React, { useState, useEffect, useContext, useRef } from 'react'
import moment from 'moment';
import styles from './RewardCalendar.module.scss'
import { CalendarDay } from '../CalendarDay'
import { Web3Context } from '../../web3/Web3Context';
import { ABIContext, IpContext, TokenContext, TYPES } from '../Context';
import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { toBN } from 'web3-utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import closeIcon from '../../assets/icons/btn-close-X.svg';
import { catchUpMissedDays, getChestInfo, getMaticToWallet, setTowerAllowanceForCatchUp, verifyCatchUp } from '../../services/starChestRewardsService';
import { TokenClaimedModal } from '../TokenClaimedModal';
import { OpenStarChestInfoModal } from '../OpenStarChestInfoModal/OpenStarChestInfoModal';
import { createContract, estimatePriorityFee } from '../../services/contractService';

import { Web3Environment } from 'ethenv';
import { GeneralModal } from '..';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { PolygonNetworkInfo } from '../../services/networkServices';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import loadingAnimation from '../../assets/imgs/loader.gif';
import iconPolygon from '../../assets/icons/icon-polygon.png';
import iconTower from '../../assets/icons/logo-tower.svg';
import { fetchTowerBalance } from '../Context/Actions';
import { InsufficientBalanceModal } from '../InsufficientBalanceModal/InsufficientBalanceModal';

const StarChestContractName = "StarChestRewardsTracker";
const MaticFaucetContractName = "FaucetContract";
const HCAPTCHA_KEY = process.env.REACT_APP_HCAPTCHA_KEY;
const FAUCET_ENABLED = process.env.REACT_APP_FAUCET_ENABLED;
const POLYGON_SCAN_URL = process.env.REACT_APP_POLYGON_BLOCK_EXPLORER_URL;

const RewardCalendar = (props) => {
    const [t] = useTranslation();
    const { currentIteration,
            remainingDays,
            endOfMonthDate,
            claimed,
            setClaimed,
            daysBonus,
            setDaysBonus,
            nextDaysBonus,
            setNextDaysBonus,
            totalEventEarnings,
            setTotalEventEarnings,
            uniquePlayerId,
            setLoading,
            walletInfo,
            countdownTime,
            cdhUserId,
            starChestInfo,
            sevenDayBonus,
            getStarChestData,
        } = props;
    const daysValue = Array.from({ length: 31}, (_, i) => i+1);
    const [wrongWallet, setWrongWallet] = useState(false);
    const [contractPaused, setContractPaused] = useState(false);
    const [tokenModal, setTokenModal] = useState({
        show: false,
        tokens: '',
        type: '',
    });
    const [starModal, setStarModal] = useState(false);
    const { web3, selectedAccount, switchNetwork, connect, provider, networkId } = useContext(Web3Context);
    const { eventEarningToken, setEventEarningTokenBalance } = useContext(IpContext);
    const [txnFailModal, setTxnFailModal] = useState({
        show: false,
        title: '',
        description: '',
    });
    const [starChestContract, setStarChestContract] = useState();
    const [maticFaucetContract, setMaticFaucetContract] = useState();
    const [captchaFail, setCaptchaFail] = useState(false);
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const captchaRef = useRef(null);
    const catchUpIndex = useRef(0);
    const [browserFingerPrint, setBrowserFingerPrint] = useState('');
    const [abiConfig] = useContext(ABIContext);
    const {
        polygonDeploymentContext,
        polygonProvider,
    } = abiConfig;
    const [catchUpProcessing, setCatchUpProcessing] = useState({
        show: false,
        towerAmount: '',
        catchUpDay: '',
        txnHash: ''
    });
    const [, tokenDispatch] = useContext(TokenContext);
    const [showInsufficientTowerModal, setShowInsufficientTowerModal] = useState(false);

    useEffect(() => {
        (async () => {
            const fpPromise = FingerprintJS.load();
            fpPromise
                .then(fp => fp.get())
                .then(result => {
                    setBrowserFingerPrint(result.visitorId)
                })
        })();
    }, [])

    useEffect(() => {
        if(starChestInfo) {
            setTotalEventEarnings(starChestInfo?.totalTowerTokensEarned || 0);
        }
    }, [starChestInfo])

    const createContracts = async () => {
        try {
            let web3M = await Web3Environment.get(process.env.REACT_APP_MATIC_PROVIDER_URL, process.env.REACT_APP_MATIC_DEPLOYMENT_CONTEXT_URL);
            let starContract = await web3M.getContract(StarChestContractName, web3, provider);
            let faucetContract = await web3M.getContract(MaticFaucetContractName, web3, provider);
            setStarChestContract(starContract);
            setMaticFaucetContract(faucetContract);
        } catch (error) {
            console.error("Error creating contracts", error);
        }
    }

    const checkValidity = async (selectedAccount) => {
        let validity = await starChestContract.methods.checkDailyTimestampValidity(selectedAccount).call();
        return validity;
    }

    useEffect(() => {
        if (web3) {
            (async () => {
                createContracts();
            })();
        }
    }, [web3])

    useEffect(() => {
        // Condition for rewards upto 28 days only
        // if (remainingDays >= 0 && (28 - currentIteration) >= 0) {
        if (remainingDays >= 0) {
            if (currentIteration > 28) {
                setDaysBonus(sevenDayBonus[currentIteration]);
            } else if (currentIteration % 7 === 0) {
                setDaysBonus(sevenDayBonus[currentIteration]);
            } else {
                setDaysBonus({
                    value: currentIteration
                });
            }
        } else {
            setDaysBonus({
                value: 0
            });
        }

        // Condition for rewards upto 28 days only
        // if (remainingDays > 0 && (28 - currentIteration) > 0) {
        if (remainingDays > 0) {
            if (currentIteration >= 28) {
                setNextDaysBonus(sevenDayBonus[currentIteration + 1]);
            } else if ((currentIteration + 1) % 7 === 0) {
                setNextDaysBonus(sevenDayBonus[currentIteration + 1]);
            } else {
                setNextDaysBonus({
                    value: currentIteration + 1
                });
            }
        } else {
            setNextDaysBonus({
                value: 1
            });
        }
    }, [currentIteration])

    const claimRewards = async () => {
        let gasPrice = await web3.eth.getGasPrice();
        let gasPriceBN = toBN(gasPrice);
        let finalGasPrice = gasPriceBN.add(toBN(parseInt(0.1 * gasPriceBN))).toString();
        let gasEstimate = await starChestContract.methods.dailyLog(uniquePlayerId).estimateGas({ from: selectedAccount });
        // Current average gasLimit is 56321. Using this value for failing transactions because of lesser gasLimit
        let finalGasEstimate = gasEstimate >= 56321 ? gasEstimate : 56321;
        let estimatedPriorityFee = await (await estimatePriorityFee(web3)).toString();
        let finalMaxFeePerGas = toBN(finalGasPrice).add(toBN(parseInt(estimatedPriorityFee))).toString();

        let checkDailyUuidValidity = await starChestContract.methods.checkDailyUuidValidity(uniquePlayerId).call();
        if (checkDailyUuidValidity) {
            const txPromise = new Promise((resolve, reject) => {
                starChestContract.methods.dailyLog(uniquePlayerId).send({
                    from: selectedAccount,
                    gasLimit: finalGasEstimate,
                    maxFeePerGas: finalMaxFeePerGas,
                    maxPriorityFeePerGas: estimatedPriorityFee
                })
                    .on('transactionHash', (txHash) => {
                        console.log(`Transaction hash obtained : ${txHash}`);
                    })
                    .on('receipt', (receipt) => {
                        resolve(receipt);
                    })
                    .on('error', e => {
                        reject(e);
                    })
            });

            await txPromise.then( async (receipt) => {
                const transactionHash = receipt.transactionHash;
                console.log(`Transaction completed with receipt.transactionHash : ${transactionHash}`);
                setClaimed(true);

                setTokenModal({
                    show: true,
                    tokens: daysBonus,
                    type: daysBonus?.type || '',
                });
            }).catch((e) => {
                console.error(`Transaction failed: ${e.message}`);
                if (e.code !== 4001) {
                    setTxnFailModal({
                        show: true,
                        title: t('ERROR'),
                        description: t('PROBLEM_GETTING_DAILY_REWARDS'),
                    });
                }
            }).finally(() => {
                setLoading(false);
            });
        } else {
            setLoading(false);
            setClaimed(true);
        }
    }

    const getPersonalSign = async () => {
        const message = 'Sign CrazyDefenseHeroes for Faucet';
        try {
            const from = selectedAccount;
            const msg = `0x${Buffer.from(message, 'utf8').toString('hex')}`;
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [msg, from, 'password'],
            });

            return sign;
        } catch (err) {
            console.error(err);
            return err;
        }
    };

    const getMaticFirstTime = async (captchaToken) => {
        try {
            let signature = await getPersonalSign();
            if (signature?.code == '4001') {
                setLoading(false);
                return;
            }

            let response = await getMaticToWallet(signature, cdhUserId, captchaToken);
            if (response?.status) {
                console.log("SUCCESS Getting Matic");
            } else {
                console.log("ERROR Getting Matic");
            }
            claimRewards();
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    }

    const handleGetMatic = async () => {
        if (starChestInfo?.faucetTransactionAlreadyRunning) {
            const interval = setInterval(async () => {
                let faucetReceived = await maticFaucetContract.methods.faucetReceived(selectedAccount).call();

                if (faucetReceived > 0) {
                    clearInterval(interval);
                    claimRewards();
                }
            }, 3000);
        } else {
            // shows hcaptcha to confirm getting matic first time
            captchaRef.current.execute();
        }
    }

    const handleClaim = async () => {
        const noMetamask = typeof window.ethereum === 'undefined' || (!window.ethereum.isMetaMask && !window.ethereum.isCoinbaseWallet && !window.ethereum.isCoinbaseBrowser);
        if (noMetamask || web3 === null) {
            connect();
            return;
        }

        if (web3 && walletInfo?.WalletId?.toLowerCase() !== selectedAccount?.toLowerCase()) {
            setWrongWallet(true);
            return;
        }

        if (web3 && starChestContract && maticFaucetContract) {
            setLoading(true);

            let switchNetworkResponse = await switchNetwork(PolygonNetworkInfo);
            if (!switchNetworkResponse) {
                setLoading(false);
                return;
            }

            let contractPaused = await starChestContract.methods.paused().call();
            if (contractPaused) {
                setContractPaused(true);
                setLoading(false);
                return;
            }

            try {
                let jwt = localStorage.getItem('jwtoken');
                let chestInfo = await getChestInfo(cdhUserId, jwt, false);
                let lengthOfStarChestInfo = chestInfo?.calender_info?.length;
                let mostRecentClaim = chestInfo?.calender_info[lengthOfStarChestInfo - 1];

                let currentDate = moment.utc(chestInfo?.currentDate);

                if (mostRecentClaim) {
                    let mostRecentClaimDate = new moment.utc(mostRecentClaim.date, 'YYYY-MM-DD');
                    if (mostRecentClaimDate.format('YYYY-MM-DD') == currentDate.format('YYYY-MM-DD') && mostRecentClaim.userSignedTransaction === false) {
                        let validity = await checkValidity(selectedAccount);

                        if (validity) {
                            if (FAUCET_ENABLED === 'true') {
                                let faucetReceived = await maticFaucetContract.methods.faucetReceived(selectedAccount).call();

                                if (faucetReceived <= 0) {
                                    // call method call api
                                    handleGetMatic();

                                } else {
                                    claimRewards();
                                }
                            } else {
                                claimRewards();
                            }
                        } else {
                            console.log(`Already checked-in for ${mostRecentClaimDate.toString()} in Blockchain`);
                            setClaimed(true);
                            setLoading(false);
                        }
                    } else if (mostRecentClaimDate.format('YYYY-MM-DD') == currentDate.format('YYYY-MM-DD') && mostRecentClaim.userSignedTransaction === true) {
                        console.log(`Already checked-in for ${mostRecentClaimDate.toString()} in Blockchain`);
                        setClaimed(true);
                        setLoading(false);
                    } else {
                        setStarModal(true);
                        setLoading(false);
                    }
                } else {
                    setStarModal(true);
                    setLoading(false);
                }
            } catch (err) {
                console.log(err);
                setLoading(false);
            }
        }
    };

    const getTowerBal = async () => {
        const towerBalance = await fetchTowerBalance(networkId, selectedAccount, polygonProvider, polygonDeploymentContext, false);
        if (towerBalance) {
            tokenDispatch({
                type: TYPES.SET_TOKEN_BALANCE,
                payload: towerBalance
            });
        }
        return towerBalance;
    }

    const delayCall = (fnCallback, delayTime) => {
        return new Promise(res => setTimeout(async () => {
            await fnCallback();
            res();
        }, delayTime));
    }

    const handleCatchUp = async (catchUpDay) => {
        setLoading(true);
        try {
            if (!selectedAccount) {
                connect();
                return;
            }

            if (web3 && walletInfo?.WalletId?.toLowerCase() !== selectedAccount?.toLowerCase()) {
                setWrongWallet(true);
                return;
            }

            let switchNetworkResponse = await switchNetwork(PolygonNetworkInfo);
            if (!switchNetworkResponse) {
                setLoading(false);
                return;
            }

            let verifyRes = await verifyCatchUp(browserFingerPrint, selectedAccount, cdhUserId);

            if (verifyRes === "pending") {
                setTxnFailModal({
                    show: true,
                    title: t('ERROR'),
                    description: <div>
                        <div>{t('Previous catch-up transaction is still pending.')}</div>
                        <div>{t('Please try again later.')}</div>
                    </div>,
                });
                setLoading(false);
                return;
            }

            const { catchupDays, playerId, amount, signature } = verifyRes;

            let towerBalance = await getTowerBal();
            if (parseInt(towerBalance) < parseInt(web3.utils.fromWei(amount))) {
                setShowInsufficientTowerModal(true);
                setLoading(false);
                return;
            }

            if (catchupDays && amount && signature) {
                const towerContract = await createContract(polygonDeploymentContext, 'PolygonTower', provider);
                const catchUpContract = await createContract(polygonDeploymentContext, 'TowerCatchUp', provider);

                if (!towerContract || !catchUpContract) {
                    throw new Error("Failed to create contract instances.");
                }

                setCatchUpProcessing({
                    show: true,
                    towerAmount: web3.utils.fromWei(amount),
                    catchUpDay: catchUpDay,
                    txnHash: ''
                });

                const allowance = await towerContract.methods.allowance(selectedAccount, catchUpContract.options.address).call();
                if (parseInt(web3.utils.fromWei(allowance)) < parseInt(web3.utils.fromWei(amount))) {
                    const MAX_256_BIT_VALUE = web3.utils.toBN(2).pow(web3.utils.toBN(256)).sub(web3.utils.toBN(1));
                    const ApproveAmount = MAX_256_BIT_VALUE.toString(10);

                    let allowanceSuccess = await setTowerAllowanceForCatchUp(towerContract, selectedAccount, catchUpContract.options.address, ApproveAmount, web3, handleCatchUpPending);
                    if (allowanceSuccess !== true) {
                        console.log("Allowance Failed.");
                        handleCatchUpPending(false, '', '', '');
                        setLoading(false);
                        return;
                    }
                }

                let catchUp = await catchUpMissedDays(catchUpContract, web3, selectedAccount, playerId, catchupDays, amount, signature, handleCatchUpPending);
                if (catchUp === true) {
                    setTokenModal({
                        show: true,
                        tokens: catchUpDay > 28 || catchUpDay % 7 === 0 ? sevenDayBonus[catchUpDay] : { value: catchUpDay },
                        type: '',
                    });

                    await delayCall(() => getStarChestData(true), 3000);
                    await getTowerBal();
                } else if (!catchUp) {
                    throw new Error("Failed processing Catch-Up transaction.");    
                }
            } else {
                throw new Error("Failed to verify catch-up action.");
            }
        } catch (err) {
            if (err.code !== 4001) {
                console.log(err);
                setTxnFailModal({
                    show: true,
                    title: t('ERROR'),
                    description: t('Failed processing Catch-Up transaction.'),
                });
            }
        }
        setLoading(false);
    }

    const handleCatchUpPending = async (show, catchUpDay, amount, txnHash) => {
        setCatchUpProcessing({
            show: show,
            towerAmount: amount,
            catchUpDay: catchUpDay,
            txnHash: txnHash
        });
    }

    const handleCatchModalShow = (show) => {
        setCatchUpProcessing({
            ...catchUpProcessing,
            show: show,
        });
    }

    const handleTxnFailModalShow = (show) => {
        setTxnFailModal({
            ...catchUpProcessing,
            show: show,
        });
    }

    useEffect(() => {
        if (daysBonus && claimed) {
            let sumEarning = totalEventEarnings + daysBonus?.value;
            setTotalEventEarnings(sumEarning);
            let overallEarn = parseFloat(eventEarningToken) + daysBonus?.value;
            setEventEarningTokenBalance(parseFloat(overallEarn).toFixed(2));
        }
    }, [claimed])

    useEffect(() => {
        if (captchaVerified) {
            getMaticFirstTime(captchaVerified);
        }
    }, [captchaVerified])

    const hanldeCaptchaClose = () => {
        setCaptchaFail(true);
        setLoading(false);
    }

    const handleCaptchaError = () => {
        setCaptchaFail(true);
        setLoading(false);
    }

    const showModalHandler = (show) => {
        setTokenModal({
            ...tokenModal,
            show: show,
        })
    }

    return (
        <div className={styles.rewards_calendar_container}>
            <HCaptcha
                sitekey={HCAPTCHA_KEY}
                size='invisible'
                onVerify={setCaptchaVerified}
                onClose={hanldeCaptchaClose}
                onError={handleCaptchaError}
                ref={captchaRef}
            />

            <div className={styles.calendar_container}>
                {currentIteration ?
                    daysValue.map((day, idx) => {
                        const missingDaysLength = starChestInfo?.missingDaysInfo?.length || 0;
                        let catchUpAmount = 0;
                        if (missingDaysLength > 0 &&claimed && day > currentIteration && day <= (currentIteration + missingDaysLength) && catchUpIndex.current < missingDaysLength) {
                            catchUpAmount = starChestInfo.missingDaysInfo[catchUpIndex.current].amount;
                            catchUpIndex.current = catchUpIndex.current + 1;
                        }
                        
                        if (day === 31) {
                            catchUpIndex.current = 0;
                        }

                        return <CalendarDay day={day}
                            currentIteration={currentIteration}
                            remainingDays={remainingDays}
                            endOfMonthDate={endOfMonthDate}
                            key={idx}
                            claimed={claimed}
                            daysBonus={daysBonus}
                            nextDaysBonus={nextDaysBonus}
                            handleClaim={handleClaim}
                            countdownTime={countdownTime}
                            setStarModal={setStarModal}
                            sevenDayBonus={sevenDayBonus}
                            catchUpAmount={catchUpAmount}
                            handleCatchUp={handleCatchUp}
                        />
                    }) : ''
                }
            </div>

            <Modal show={wrongWallet} className={styles.reward_modal}  centered contentClassName={styles.reward_modalContent} dialogClassName={styles.reward_modalDialog} onHide={() => setWrongWallet(false)}>
                <button className={styles.close_btn} onClick={() => setWrongWallet(false)}>
                    <img src={closeIcon} alt="close" />
                </button>
                <Modal.Body bsPrefix={styles.reward_modalBody}>
                    <div className={styles.reward_title}>{t('WRONG_WALLET_PLEASE_SWITCH_LINKED_WALLET')} ({`${walletInfo.WalletId.substr(0,6)}...${walletInfo.WalletId.substr(walletInfo.WalletId.length - 4)}`})</div>
                    <div className={styles.btn}>
                        <Button variant='cdh-general-blue' onClick={()=> setWrongWallet(false)}>{t('CLOSE').toUpperCase()}</Button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={contractPaused} className={styles.reward_modal}  centered contentClassName={styles.reward_modalContent} dialogClassName={styles.reward_modalDialog} onHide={() => setContractPaused(false)}>
                <button className={styles.close_btn} onClick={() => setContractPaused(false)}>
                    <img src={closeIcon} alt="close" />
                </button>
                <Modal.Body bsPrefix={styles.reward_modalBody}>
                    <div className={styles.reward_title}>{t('Check-in for Rewards is paused right now.')}</div>
                    <div className={styles.btn}>
                        <Button variant='cdh-general-blue' onClick={()=> setContractPaused(false)}>{t('CLOSE').toUpperCase()}</Button>
                    </div>
                </Modal.Body>
            </Modal>

            <GeneralModal content={{
                show: txnFailModal.show,
                showSetter: handleTxnFailModalShow,
                title: txnFailModal.title,
                description: txnFailModal.description,
                buttonText: t('CLOSE'),
                buttonCallback: () => handleTxnFailModalShow(false)
            }} />

            <TokenClaimedModal
                open={tokenModal.show}
                setOpen={showModalHandler}
                tokens={tokenModal.tokens}
                type={tokenModal.type}
            />
            <OpenStarChestInfoModal
                starModal={starModal}
                setStarModal={setStarModal}
                title={t('CHEST_NOT_OPENED_YET')}
                body={t('EARN_STAR_CHEST_GETTING_STARS_IN_GAME')}
            />

            <Modal show={captchaFail} className={styles.error_modal} onHide={() => setCaptchaFail(false)} centered>
                <div className={styles.close_btn} onClick={() => setCaptchaFail(false)}><FontAwesomeIcon icon={faTimes}/></div>
                <Modal.Header className={styles.error_modal_header}>
                    <Modal.Title className={styles.modal_title}>{t('CAPTCHA_FAIL')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className={styles.error_modal_body}>
                    <div className={styles.error_modal_body_text}>{t('CAPTCHA_FAIL') + ' ' + t('TRY_AGAIN')}</div>
                    <HCaptcha
                        sitekey={HCAPTCHA_KEY}
                        size='compact'
                        onVerify={setCaptchaVerified}
                        onClose={hanldeCaptchaClose}
                        onError={handleCaptchaError}
                    />
                </Modal.Body>
                <Modal.Footer className={styles.error_modal_footer}>
                    <Button variant="cdh-general-blue" className={styles.modal_ok_btn} onClick={() => setCaptchaFail(false)}>{t('CLOSE')}</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={catchUpProcessing.show} className={styles.error_modal} onHide={() => handleCatchModalShow(false)} centered>
                <div className={styles.close_btn} onClick={() => handleCatchModalShow(false)}><FontAwesomeIcon icon={faTimes}/></div>
                <Modal.Header className={styles.error_modal_header}>
                    <Modal.Title className={styles.modal_title}>{t('DAILY_STAR_CHEST_CALENDAR_CATCH_UP')}</Modal.Title>
                </Modal.Header>
                <Modal.Body className={styles.error_modal_body}>
                    <img src={loadingAnimation} alt="loading" className={styles.loading_img} />
                    <h2>{t('TRANSACTION_PROCESSING')}</h2>
                    <div>
                        <div className='d-flex align-items-center justify-content-center'>{t('CHECK_WALLET_CONFIRM_PAYING')} <img src={iconTower} alt="tower" style={{ width: "20px" }} />{catchUpProcessing.towerAmount}</div>
                        <div>{t('TO_CATCH_UP_THE')} {catchUpProcessing.catchUpDay}th {t('DAY_OF_CALENDAR_REWARDS')}</div>
                    </div>
                </Modal.Body>
                <Modal.Footer className={styles.error_modal_footer}>
                {catchUpProcessing.txnHash ? (
                    <div className={styles.bottom_link}>
                        <a href={`${POLYGON_SCAN_URL}tx/${catchUpProcessing.txnHash}`} target="_blank" rel="noopener noreferrer">
                            <img src={iconPolygon} alt='' />
                            View on PolygonScan
                        </a>
                    </div>
                ) : null}
                </Modal.Footer>
            </Modal>

            <InsufficientBalanceModal
                content={{
                    show: showInsufficientTowerModal,
                    closeModal: () => setShowInsufficientTowerModal(false),
                    title: 'OOPS.. You do not have enough $TOWER',
                    description: 'Please get more $TOWER.',
                    buttonText: 'Get TOWER',
            }} />
        </div>
    )
}

export {RewardCalendar}
